import React from "react";
import "../../styles/Language.css";
import Header from "../../ReUseAbleComp/Header.jsx";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Units = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <>
      <Helmet>
        <title>Urdu Units</title>
      </Helmet>
      <div className="bg-image"></div>
      <Header
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
      <div className="mix_title">
        <h1 className="mix_title_text">
          Creating awareness for strengthening Local Governance
          <br />
          <span className="mix_title_text_urdu">
            اگاہی براے مستحکم مقامی نظام
          </span>
        </h1>
      </div>

      <div className="lang_langSelect">
        <Link to="/LGUrdu" className="res-circle">
          <div className="circle-txt">مقامی حکومت</div>
        </Link>
        <Link to="/CovidUrduTopics" className="res-circle">
          <div className="circle-txt">کورونا وائرس</div>
        </Link>
        <Link to="/GeneralUrduTopics" className="res-circle">
          <div className="circle-txt">جنرل</div>
        </Link>
      </div>
    </>
  );
};

export default Units;
